import { FC } from 'react'
import { GridDiv } from 'featureSliced/shared/utils/gridDiv'
import { RenderIf } from 'components/RenderIf'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { Button } from 'featureSliced/entities/Button'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

import { CurrentPageType } from '../types'
import { FooterContainer, Total } from './styled'

type FooterPaymentQRMProps = {
  currentPage: CurrentPageType
  setCurrentPage: (value: CurrentPageType) => void
  getIsNextAndPayDisabled: () => boolean
  tipsValue: number
  startPaymentProccess: () => void
  isLoading: boolean
  getResultPrice: () => string
}

export const FooterPaymentQRM: FC<FooterPaymentQRMProps> = ({
  currentPage,
  setCurrentPage,
  getIsNextAndPayDisabled,
  startPaymentProccess,
  isLoading,
  getResultPrice,
}) => {
  // Hooks
  const t = useTranslations()

  // Store
  const isTipsAllowed = useMySelector((state) => state.app.menu.tips)
  const isSelfServiceEnabled = useMySelector(
    (state) => state.app.menu.selfService
  )

  // Functions
  const handleNextCartAndSplit = () => {
    if (currentPage === 'cart') {
      if (isSelfServiceEnabled) {
        setCurrentPage('selfService')
      } else if (isTipsAllowed) {
        setCurrentPage('tips')
      } else {
        startPaymentProccess()
      }
    }
    if (currentPage === 'selfService') {
      // check phone number and name
      if (isTipsAllowed) {
        setCurrentPage('tips')
      } else {
        startPaymentProccess()
      }
    }
    if (currentPage === 'tips') {
      startPaymentProccess()
    }
  }

  return (
    <FooterContainer>
      <Total>
        <span>{t('common.total')}:</span>
        <span>{getResultPrice()}</span>
      </Total>

      {/* CART */}
      <RenderIf condition={currentPage === 'cart'}>
        <div />
        <Button
          buttonType="common"
          onClick={handleNextCartAndSplit}
          disabled={getIsNextAndPayDisabled()}
          width="100%"
          isLoading={isLoading}
        >
          {isTipsAllowed || isSelfServiceEnabled
            ? t('auth.confirmButton')
            : t('cover.pay')}
        </Button>
      </RenderIf>

      {/* SELF_SEVICE */}
      <RenderIf condition={currentPage === 'selfService'}>
        <GridDiv gc="1/-1">
          <Button
            buttonType="common"
            onClick={handleNextCartAndSplit}
            // TODO: check if name & number filled
            disabled={getIsNextAndPayDisabled()}
            width="100%"
            isLoading={isLoading}
          >
            {isTipsAllowed ? t('common.next') : t('buttons.checkout')}
          </Button>
        </GridDiv>
      </RenderIf>

      {/* TIPS */}
      <RenderIf condition={currentPage === 'tips'}>
        <GridDiv gc="1/-1">
          <Button
            buttonType="common"
            onClick={startPaymentProccess}
            disabled={getIsNextAndPayDisabled()}
            width="100%"
            isLoading={isLoading}
          >
            {t('buttons.checkout')} ({getResultPrice()})
          </Button>
        </GridDiv>
      </RenderIf>
    </FooterContainer>
  )
}
